import React, { useState } from "react";

import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { BaseBean, RestReportBean } from "../ds/client_ds.js";
import {
  FabricStyleSearchCriteria,
  FabricStyleSKUBean,
  PageListBean,
  RestFabricStyleListBeanRequest,
  RestPageListBean,
  RestReadRequest,
  RestVendorListRequest,
  RestVendorPurchaseOnOrderListRequest,
  VendorOnOrderPrintReport_dorellRequest,
  VendorOnOrderPrintRequest,
  VendorPurchaseOnOrderDetailsBean,
  VendorPurchaseOnOrderSearchCriteria,
  VendorSearchCriteria,
} from "../ds/ds.js";
import {
  AlertToolBox,
  CollapseComponent,
  DatePickerComponent_adv,
  InputTextbox,
  MultiViewPopup,
  NumberFormatInputbox,
  ProgressBar,
  ShowError,
  ColumnDefinition
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toDownloadReportAddress,
} from "../gui_components/Util.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { VendorLookupHandler } from "../lookup/VendorLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupFabricStyleModule,
  PopupPurchaseOrderModule,
  PopupVendorModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { ReportService } from "../services/ReportService.js";
import { VendorService } from "../services/VendorService.js";
import CustomTable from "../gui_components/CustomTable.js";
class VendorOnOrder extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Vendor OnOrder Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isShowExitButton: true,
      error_list: [],
      inquiryDataList: [],
      POCustomerReservedDetails: [],
      summaryData: null,
      criteria: new VendorPurchaseOnOrderSearchCriteria(),
      criteriaViewShow: false,
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMessage: "",
      isShowAlertlvl1: false,
      success_list: [],
      isShowFabricStyleModule: false,
      isShowVendorModule: false,
      isShowPurchaseOrderModule: false,
      moduleForPopup: [],
      isShowColorLookup: false,
      isCollapsible_open: true,
      showAutoCompleteList: true,
      vendorPageListForAutoCompleteList: new Array(),
      showAutoCompleteVendorList: true,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricList: true,
      showAutoCompleteFabricColorList: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isShowCriteriaView: true,
      fabricVendorAtsInfoBean: new VendorPurchaseOnOrderDetailsBean(),
      isShowVendorQtyPopup: false,
      vendorQtyDataList: [],
      POCustomerReservedDetails: [],
      showAutoCompleteLocationList: true,
      locationPageListForAutoCompleteList: new Array(),
      locations: [],
      colorList: [],
      isDisableFields: false,
      order: "asc",
      sortField: "",
      is3PL: false,
    };
    this.vendorCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.report_url = appData.reportURL;
    this.initLookupHandlers();
    if (this.props.vendorCode !== "" && this.props.vendorCode !== undefined) {
      let temp_Criteria = this.state.criteria;
      temp_Criteria.vendorCode = this.props.vendorCode;
      this.setState({
        criteria: temp_Criteria,
        isShowCriteriaView: false,
        isShowResetButton: false,
        isShowExecuteButton: false,
        isShowClearCriteriaButton: false,
      });
      this.loadPage(1);
    }
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let warehouses = attribute_cache.warehouses;
    if (warehouses != null || warehouses != undefined) {
      warehouses.map((attr) => {
        this.state.locations.push(attr);
      });
    }
  }
  initLookupHandlers = () => {
    let vendorLookupHandler = new VendorLookupHandler(
      this.companyCode,
      "Vendor"
    );
    this.setState({ vendorLookupHandler: vendorLookupHandler });
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
    let locationLookupHandler = new GenericAttributeLookupHandler(
      this.state.locations,
      "Location"
    );
    this.setState({ locationLookupHandler: locationLookupHandler });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.showAutoCompleteList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
        isShowColorLookup: false,
        colorList: [],
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetFabricStyleDetailResponse = (response) => {
    let criteria = this.state.criteria;
    this.setState({ isFabricStyleDataLoding: false });
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;
        let colors = fabricStyle.colors;
        let finalColorList = [];
        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        this.setState({ colorLookupHandler: null });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color"
          );
          this.setState({
            colorLookupHandler: colorLookupHandler,
            isShowColorLookup: true,
            criteria: criteria,
            colorList: finalColorList,
            fabricStyleData: fabricStyle,
            isShowProgressBarPopup: false,
            progressLoadingText: "",
          });
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readandsetFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyle(
      input,
      this.readandsetFabricStyleDetailResponse,
      this.errorCallBack
    );
  };

  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.errorCallBack
    );
  }
  readByFabricCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: fabricStyle.fabricStyleName,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.readandsetFabricStyleDetail(e.target.value);
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
    });
    this.setState({ fabricPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteList });
  };
  locationCodeOnChange = (e) => {
    let locationCode = e.target.value;
    this.state.showAutoCompleteLocationList = true;
    let temp_criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteLocationList;
    if (isEmpty(locationCode)) {
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      let criteria = this.state.criteria;
      criteria.locationCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteLocationList: showAutoCompleteList,
        criteria: criteria,
        locationPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && locationCode !== "") {
      this.readLocationBySearchString(locationCode);
    }
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ criteria: temp_criteria });
    this.readLocation(locationCode);
  };
  readLocation = (locationCode) => {
    let locationBean = null;
    let locationData = null;
    this.state.locations.map((ln) => {
      if (ln.code === locationCode) {
        locationBean = ln;
        locationData = new BaseBean();
        locationData.code = ln.code;
        locationData.description = ln.description;
      }
    });
    if (!isEmpty(locationBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.locationCode = locationBean.code;
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      this.setState({
        criteria: temp_criteria,
        showAutoCompleteList: showAutoCompleteList,
      });
    }
    this.setState({ locationList: locationBean, locationData: locationData });
  };
  readLocationBySearchString = (searchString) => {
    let locationData = this.state.locations;
    let simpleAutoCompleteList = new Array();
    if (locationData.length > 0 && locationData != null) {
      locationData.map((sp) => {
        let locationBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(locationBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      locationPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  locationEnterKeyEventHandler = (e) => {
    let locationCode = e.target.value;
    this.readLocation(locationCode);
    this.setState({
      locationPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteLocationList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteLocationList: showAutoCompleteList });
  };
  onFabricColourCodeChange = (e) => {
    this.state.showAutoCompleteFabricColorList = true;
    let colorCode = e.target.value;
    let showAutoCompleteFabricColorList =
      this.state.showAutoCompleteFabricColorList;
    if (isEmpty(colorCode)) {
      this.state.showAutoCompleteFabricColorList = false;
      let showAutoCompleteFabricColorList =
        this.state.showAutoCompleteFabricColorList;
      let criteria = this.state.criteria;
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "colorCode" &&
      showAutoCompleteFabricColorList === true &&
      colorCode !== ""
    ) {
      this.readFabricColourBySearchString(e.target.value);
    }
    this.fabricStyleColorSelected(e.target.value);
  };
  readFabricColourBySearchString(searchString) {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.fabricStyleColorCode == searchString
        )
          skuBean = sku;
      });
    }
    criteria.colorCode = searchString;
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColourEnterKeyEventHandler = (e) => {
    this.fabricStyleColorSelected(e.target.value);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricColorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricColorList: showAutoCompleteList });
  };
  fabricStyleColorSelected = (colorCode) => {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.fabricStyleColorCode == colorCode
        )
          skuBean = sku;
      });
    }
    criteria.colorCode = colorCode;
    this.setState({ criteria: criteria });
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let vend_criteria = new VendorPurchaseOnOrderSearchCriteria();
    vend_criteria.companyCode = this.companyCode;
    vend_criteria.vendorCode = criteria.vendorCode;
    vend_criteria.fabricStyleCode = criteria.fabricStyleCode;
    vend_criteria.colorCode = criteria.colorCode;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 20;
    pageInput.currentPage = pageNumber;
    let listRequest = new RestVendorPurchaseOnOrderListRequest();
    listRequest.searchCriteria = criteria;
    listRequest.pageInput = pageInput;
    listRequest.isStartDateBased = true;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    this.loadVendorOnOrderInquiryList(vend_criteria);
  };
  loadVendorOnOrderInquiryList = (listRequest) => {
    if (SecurityAccessManager.VendorOnOrderInquiry_IsAccessible()) {
      VendorService.getVendorPurchaseOnOrderDetails(
        listRequest,
        this.loadVendorOnOrderQtyPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadVendorOnOrderQtyPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.orderDetailsResult != null) {
      let vendorQtyDataList = [];
      let POCustomerReservedDetails = [];
      if (!isEmptyArray(response.data.orderDetailsResult.onOrderInfoDetails)) {
        vendorQtyDataList = response.data.orderDetailsResult.onOrderInfoDetails;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      if (
        !isEmptyArray(
          response.data.orderDetailsResult.customerReservedDetailLines
        )
      ) {
        POCustomerReservedDetails =
          response.data.orderDetailsResult.customerReservedDetailLines;
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        inquiryDataList: vendorQtyDataList,
        POCustomerReservedDetails: POCustomerReservedDetails,
        isShowClearCriteriaButton: false,
        isCollapsible_open: false,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
        isShowColorLookup: false,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateVendorOnOrderReport = (reportType) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new VendorOnOrderPrintReport_dorellRequest();
    listRequest.criteria = criteria;
    listRequest.input = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      if (SecurityAccessManager.VendorOnOrderInquiryPDFReport_IsAccessible()) {
        ReportService.generateVendorOnOrderPrintReport_dorell(
          listRequest,
          this.generateVendorOnOrderResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.VendorOnOrderInquiryExcelReport_IsAccessible()
      ) {
        ReportService.generateVendorOnOrderPrintReport_dorell(
          listRequest,
          this.generateVendorOnOrderExcelResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
 generateVendorOnOrderResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

    generateVendorOnOrderExcelResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
          let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
        window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };

  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new VendorPurchaseOnOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleName = "";
    this.setState({
      criteria: criteria,
      isShowColorLookup: false,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricStyleData: new Array(),
      colorList: [],
      isDisableFields: false,
      isShowClearCriteriaButton: true,
    });
  };
  resetInquiry = () => {
    let criteria = new VendorPurchaseOnOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleName = "";
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowResetButton: false,
      isCollapsible_open: true,
      isShowColorLookup: false,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricStyleData: new Array(),
      colorList: [],
      isDisableFields: false,
      isShowClearCriteriaButton: true,
    });
    this.hideAlertCallBack();
  };
  showHideSecondHeader = () => {
    let tempIsCollapsible_open = !this.state.isCollapsible_open;
    this.setState({ isCollapsible_open: tempIsCollapsible_open });
  };
  generatePDF = () => {
    this.generateVendorOnOrderReport(1);
  };
  generateExcel = () => {
    this.generateVendorOnOrderReport(2);
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewFabricModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricStyleModule: true,
          moduleForPopup: (
            <PopupFabricStyleModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewVendorModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowVendorModule: true,
          moduleForPopup: (
            <PopupVendorModule
              vendorCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPurchaseOrderModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseOrderModule: true,
          moduleForPopup: (
            <PopupPurchaseOrderModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  vendorOnOrderQtyClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let fabricVendorAtsInfoBean = new VendorPurchaseOnOrderDetailsBean();
      fabricVendorAtsInfoBean.companyCode = this.companyCode;
      fabricVendorAtsInfoBean.fabricStyleCode = rowData.fabricStyleCode;
      fabricVendorAtsInfoBean.fabricStyleShortName =
        rowData.fabricStyleShortName;
      fabricVendorAtsInfoBean.colorCode = rowData.colorCode;
      fabricVendorAtsInfoBean.onOrderQuantity = rowData.onOrderQuantity;
      fabricVendorAtsInfoBean.inTransitQuantity = rowData.inTransitQuantity;
      this.setState({ fabricVendorAtsInfoBean: fabricVendorAtsInfoBean });
      let vendorQtyCriteria = new VendorPurchaseOnOrderSearchCriteria();
      vendorQtyCriteria.companyCode = this.companyCode;
      vendorQtyCriteria.fabricStyleCode = rowData.fabricStyleCode;
      vendorQtyCriteria.colorCode = rowData.fabricStyleColorCode;
      vendorQtyCriteria.excludedLocationCodes =
        this.state.criteria.excludedLocationCodes;
      let pageInput = new RestPageListBean();
      pageInput.pageSize = 20;
      pageInput.currentPage = 1;
      let listRequest = new RestVendorPurchaseOnOrderListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = vendorQtyCriteria;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Fetching Vendor OnOrder Qty...",
      });
      if (rowData.vendorOnOrderQuantity != 0) {
        this.loadVendorOnOrderQtyListPage(listRequest);
      } else {
        let errMsg = "No data found";
        let errList = [];
        errList.push(errMsg);
        this.setState({ error_list: errList });
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
  };
  loadVendorOnOrderQtyListPage = (listRequest) => {
    if (SecurityAccessManager.VendorOnOrderInquiry_IsAccessible()) {
      VendorService.getVendorPurchaseOnOrderDetailsForFabricStyleStatistics(
        listRequest,
        this.loadPOFabricStatisticsResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadPOFabricStatisticsResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.orderDetailsResult != null) {
      let vendorQtyDataList = [];
      let POCustomerReservedDetails = [];
      if (
        response.data.orderDetailsResult.customerReservedDetailLines != null
      ) {
        vendorQtyDataList = response.data.orderDetailsResult.onOrderInfoDetails;
      }
      if (
        response.data.orderDetailsResult.customerReservedDetailLines != null
      ) {
        POCustomerReservedDetails =
          response.data.orderDetailsResult.customerReservedDetailLines;
      }
      this.setState({
        vendorQtyDataList: vendorQtyDataList,
        POCustomerReservedDetails: POCustomerReservedDetails,
        isShowVendorQtyPopup: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  generatePopupVendorOnOrderPdf = (e) => {
    if (e.detail === 1) this.generatePopupVendorOnOrderReport(1);
  };
  generatePopupVendorOnOrderExcel = (e) => {
    if (e.detail === 1) this.generatePopupVendorOnOrderReport(2);
  };
  generatePopupVendorOnOrderReport = (reportType) => {
    let fabricVendorAtsInfoBean = this.state.fabricVendorAtsInfoBean;
    let criteria = new VendorPurchaseOnOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricVendorAtsInfoBean.fabricStyleCode;
    criteria.colorCode = fabricVendorAtsInfoBean.colorCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new VendorOnOrderPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (
      this.state.POCustomerReservedDetails != null &&
      !isEmptyArray(this.state.POCustomerReservedDetails)
    ) {
      if (SecurityAccessManager.VendorOnOrderInquiry_IsAccessible()) {
        ReportService.generatePopupVendorOnOrderPrintReport(
          listRequest,
          this.generatePopupVendorOnOrderResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(1);
      }
    } else {
      let errMsg = "No Report Generated";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlertlvl1: true,
      });
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  generatePopupVendorOnOrderResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  hideAlertCallBackLvl1 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertlvl1: isDisplayed, error_list: [] });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowFabricStyleModule: isOpen,
      isShowVendorModule: isOpen,
      isShowPurchaseOrderModule: isOpen,
      moduleForPopup: [],
    });
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowVendorQtyPopup: isShowPopup,
    });
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  vendorCodeOnChange = (e) => {
    let vendorCode = e.target.value;
    this.state.showAutoCompleteVendorList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteVendorList;
    if (isEmpty(vendorCode)) {
      this.state.showAutoCompleteVendorList = false;
      let showAutoCompleteList = this.state.showAutoCompleteVendorList;
      let criteria = this.state.criteria;
      criteria.vendorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        vendorPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "vendorCode" &&
      showAutoCompleteList === true &&
      vendorCode !== ""
    ) {
      this.readVendorBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetVendorDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.vendor != null) {
      let vendorData = response.data.vendor;
      if (!isEmpty(vendorData)) {
        criteria.vendorName = vendorData.description;
        criteria.vendorCode = vendorData.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  readandsetVendorDetail = (vendorCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = vendorCode;
    input.isLoadChildren = true;
    VendorService.readVendor(
      input,
      this.readandsetVendorDetailResponse,
      this.errorCallBack
    );
  };
  readVendorBySearchString(searchString) {
    let searchCriteria = new VendorSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.vendorCodeStartsWith = searchString;
    searchCriteria.vendorNameContains = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestVendorListRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    VendorService.getVendorPageList(
      input,
      this.readByVendorCodeResponse,
      this.errorCallBack
    );
  }
  readByVendorCodeResponse = (response) => {
    let vendorCodeData = response.data.vendorPageList.vendors;
    let simpleAutoCompleteList = new Array();
    if (vendorCodeData.length > 0 && vendorCodeData != null) {
      vendorCodeData.map((vendorCode) => {
        let simpleItemBean = {
          code: vendorCode.code,
          description: vendorCode.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      vendorPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  vendorCodeEnterKeyEventHandler = (e) => {
    let vendorCode = e.target.value;
    this.readandsetVendorDetail(vendorCode);
    this.setState({
      vendorPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteVendorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteVendorList: showAutoCompleteList });
  };

  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "Vendor#",
          "vendorCode",
          true
        )
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewVendorModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "VendorName",
          "vendorName",
          true
        )
        .setStyleDetails("left", "8", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "FabricStyle",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "7", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Vendor OnOrder Qty", "onOrderQuantity", true, true)
        .setStyleDetails("right", "2", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.vendorOnOrderQtyClick, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("P.O#", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewPurchaseOrderModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OrderDate", "orderDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("P.OStartDate", "purchaseOrderStartDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("P.OStopDate", "purchaseOrderStopDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("XFactoryDate", "xFactoryDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("IndcDate", "inDCDate", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("EtaDate", "etaDate", true)
        .setStyleDetails("left", "2", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("InConsoleDCDate", "inConsolidatorDCDate", true)
        .setStyleDetails("left", "2", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Width", "widthCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Sku", "skuNumber", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "orderUom", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("FabricStyle Name", "fabricStyleShortName", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Pro.Status", "productionStatus", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Pro.Notes", "productionNotes", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    return columns;
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let is3PL = this.state.is3PL;
    let criteria = this.state.criteria;
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = pageList.pageSize;
    let totalCount = pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    let isLoading = this.state.isLoading;
    let fabricVendorAtsInfoBean = this.state.fabricVendorAtsInfoBean;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          {...this.state}
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
          onModuleExit={this.onModuleExit}
        />
        {this.state.isShowCriteriaView ? (
          <CriteriaView
            {...this.state}
            loadPage={this.loadPage}
            onChange={this.onChange}
            fabricLookupHandler={this.state.fabricLookupHandler}
            vendorLookupHandler={this.state.vendorLookupHandler}
            locationLookupHandler={this.state.locationLookupHandler}
            fabricCodeOnChange={this.fabricCodeOnChange}
            showHideSecondHeader={this.showHideSecondHeader}
            vendorCodeRef={this.vendorCodeRef}
            vendorCodeEnterKeyEventHandler={this.vendorCodeEnterKeyEventHandler}
            displayAutoCompleteVendorList={this.displayAutoCompleteVendorList}
            vendorCodeOnChange={this.vendorCodeOnChange}
            fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
            displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
            fabricColourEnterKeyEventHandler={
              this.fabricColourEnterKeyEventHandler
            }
            displayAutoCompleteFabricColorList={
              this.displayAutoCompleteFabricColorList
            }
            onFabricColourCodeChange={this.onFabricColourCodeChange}
            locationCodeOnChange={this.locationCodeOnChange}
            locationEnterKeyEventHandler={this.locationEnterKeyEventHandler}
            displayAutoCompleteLocationList={
              this.displayAutoCompleteLocationList
            }
          />
        ) : null}
        {this.state.isInquiryDatasFound && (
          <div className="mt-3">
            <CustomTable
              data={inquiryDataList}
              columns={this.inquiryColumns()}
              enableVritualizer={true}
            />
          </div>
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowVendorModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowPurchaseOrderModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowVendorQtyPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel1"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"VendorOnOrderDetails"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertlvl1}
              hideAlertCallBack={this.hideAlertCallBackLvl1}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generatePopupVendorOnOrderPdf(e)}
              >
                PDF
              </Button>
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generatePopupVendorOnOrderExcel(e)}
              >
                Excel
              </Button>
            </div>
          }
          content={
            <div>
              <VendorOnOrderDetailsForm
                {...this.state}
                fabricVendorAtsInfoBean={this.state.fabricVendorAtsInfoBean}
                vendorQtyDataList={this.state.vendorQtyDataList}
                POCustomerReservedDetails={this.state.POCustomerReservedDetails}
              />
            </div>
          }
        />
      </div>
    );
  }
}
class VendorOnOrderDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      isShowCustomerModule: false,
      isShowSalesModule: false,
      isShowVendorModule: false,
      isShowPurchaseOrderModule: false,
      modulePopup: [],
    };
  }
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowCustomerModule: isOpen,
      isShowSalesModule: isOpen,
      isShowVendorModule: isOpen,
      isShowPurchaseOrderModule: isOpen,
      moduleForPopup: [],
    });
  };
  vndorOnOrderColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("P.O#", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("L.n#", "purchaseOrderLineNumber", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "Customer",
          "reserveCustomerCode",
          true
        )
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "CustomerName",
          "reserveCustomerName",
          true
        )
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OrderQty", "orderType", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Remarks", "remarks", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );
    return columns;
  };
  render() {
    let fabricVendorAtsInfoData = this.props.fabricVendorAtsInfoBean;
    let POCustomerReservedDetailList = this.props.POCustomerReservedDetails;
    let is3PL = this.props.is3PL;
    return (
      <div>
        <Row>
          {is3PL ? (
            <Col sm="1">
              <FormLabel>Item</FormLabel>
            </Col>
          ) : (
            <Col sm="1">
              <FormLabel>FabricStyle</FormLabel>
            </Col>
          )}
          <Col sm="2">
            <InputTextbox
              name="fabricStyleCode"
              type="text"
              value={fabricVendorAtsInfoData.fabricStyleCode}
              disabled={true}
            />
          </Col>
          <Col sm="2">
            <InputTextbox
              name="fabricStyleName"
              type="text"
              value={fabricVendorAtsInfoData.fabricStyleShortName}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>ColorCode</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="fabricStyleColorCode"
              type="text"
              value={fabricVendorAtsInfoData.colorCode}
              disabled={true}
            />
          </Col>

          <Col sm="1">
            <FormLabel>InTransit Qty</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="inTransitQuantity"
              type="text"
              className="summary_input text-right"
              value={fabricVendorAtsInfoData.inTransitQuantity}
              disabled={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>onOrderQty</FormLabel>
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              value={fabricVendorAtsInfoData.onOrderQuantity}
              className="summary_input text-right"
              decimalScale={2}
              name={"vendorOnOrderQuantity"}
              disabled={true}
            />
          </Col>
        </Row>
        <div className="mt-3">
          <CustomTable
            data={POCustomerReservedDetailList}
            columns={this.vndorOnOrderColumns()}
            enableVritualizer={true}
            label={"Purchase Order Customer Reserved Details"}
          />
        </div>
      </div>
    );
  }
}
export function CriteriaView(props) {
  const [show, setShow] = useState(false);
  const handleButton = () => setShow(!show);
  const onChange = (e) => props.onChange(e);
  const loadPage = () => {
    handleButton();
    props.loadPage(1);
  };
  const fabricCodeOnChange = (e) => props.fabricCodeOnChange(e);
  let criteria = props.criteria;
  let isShowColorLookup = props.isShowColorLookup;
  let fabricLookupHandler = props.fabricLookupHandler;
  let vendorLookupHandler = props.vendorLookupHandler;
  let colorLookupHandler = props.colorLookupHandler;
  let fabricCodeRef = React.createRef();
  const vendorCodeRef = props.vendorCodeRef;
  let colorCodeRef = React.createRef();
  let isDisableFields = props.isDisableFields;
  const showHideSecondHeader = (e) => {
    if (e.detail === 1) props.showHideSecondHeader();
  };
  const vendorCodeEnterKeyEventHandler = (e) => {
    props.vendorCodeEnterKeyEventHandler(e);
  };
  const displayAutoCompleteVendorList = () => {
    props.displayAutoCompleteVendorList();
  };
  const vendorCodeOnChange = (e) => {
    props.vendorCodeOnChange(e);
  };
  const onFabricColourCodeChange = (e) => {
    props.onFabricColourCodeChange(e);
  };
  const fabricEnterKeyEventHandler = (e) => {
    props.fabricEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricList = () => {
    props.displayAutoCompleteFabricList();
  };
  const fabricColourEnterKeyEventHandler = (e) => {
    props.fabricColourEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricColorList = () => {
    props.displayAutoCompleteFabricColorList();
  };
  let locationLookupHandler = props.locationLookupHandler;
  const locationEnterKeyEventHandler = (e) => {
    props.locationEnterKeyEventHandler(e);
  };
  const displayAutoCompleteLocationList = () => {
    props.displayAutoCompleteLocationList();
  };
  const locationCodeOnChange = (e) => {
    props.locationCodeOnChange(e);
  };
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          {" "}
          <FormLabel>Vendor</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={vendorCodeRef}
            name="vendorCode"
            onChange={vendorCodeOnChange}
            value={criteria.vendorCode}
            lookupRequired={true}
            lookupHandler={vendorLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={vendorCodeEnterKeyEventHandler}
            autoCompleteListData={props.vendorPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteVendorList}
            showAutoCompleteList={props.showAutoCompleteVendorList}
            disabled={isDisableFields}
            isMandatory={true}
          />
        </Col>

        <Col sm="1">
          {props.is3PL ? (
            <FormLabel>Item</FormLabel>
          ) : (
            <FormLabel>FabricStyle</FormLabel>
          )}
        </Col>

        <Col sm="2">
          <InputTextbox
            ref={fabricCodeRef}
            name="fabricStyleCode"
            onChange={fabricCodeOnChange}
            value={criteria.fabricStyleCode}
            lookupRequired={true}
            lookupHandler={fabricLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={fabricEnterKeyEventHandler}
            autoCompleteListData={props.fabricPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteFabricList}
            showAutoCompleteList={props.showAutoCompleteFabricList}
            disabled={isDisableFields}
          />
        </Col>
        <Col sm="2">
          <InputTextbox
            name="fabricStyleName"
            onChange={onChange}
            value={criteria.fabricStyleName}
            disabled={true}
          />
        </Col>
        <Col sm="1">
          {" "}
          <FormLabel>Color</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={colorCodeRef}
            onChange={onFabricColourCodeChange}
            name="colorCode"
            placeholder="color"
            value={criteria.colorCode}
            lookupRequired={isShowColorLookup}
            lookupHandler={colorLookupHandler}
            enterKeyEventHandler={fabricColourEnterKeyEventHandler}
            autoCompleteListData={props.fabricColourPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteFabricColorList}
            showAutoCompleteList={props.showAutoCompleteFabricColorList}
            disabled={!isShowColorLookup}
          />
        </Col>
        <Col>
          <CollapseComponent
            isOpen={props.isCollapsible_open}
            onClick={(e) => showHideSecondHeader(e)}
          />
        </Col>
      </Row>
      {props.isCollapsible_open && (
        <Row className="d-flex justify-content-left">
          <Col sm="1">
            {" "}
            <FormLabel>OrderStartDate From</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent_adv
              name="orderStopFromDate"
              value={criteria.orderStopFromDate}
              onChange={onChange}
              disabled={isDisableFields}
            />
          </Col>
          <Col sm="1">
            <FormLabel>OrderStartDate To</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent_adv
              name="orderStopToDate"
              onChange={onChange}
              value={criteria.orderStopToDate}
              disabled={isDisableFields}
            />
          </Col>
        </Row>
      )}
    </div>
  );
}
function VendorOnOrderInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <VendorOnOrder {...props} name="" /> <br />
    </div>
  );
}

export default VendorOnOrderInquiry;
